/**
 * Helpers for a `SubjectDto` — a user or a group, as the pickers and the
 * grant and assignee lists show one.
 */
import type { SubjectDto } from '@forsys/shared';
import i18n from '../i18n';

/**
 * `user:7` — a stable key for a subject.
 *
 * A user and a group may share an id, so the type has to be in it. The same
 * shape the backend uses for a rule's audience and the CLI's `--to`.
 */
export function subjectKey(subject: Pick<SubjectDto, 'type' | 'id'>): string {
  return `${subject.type}:${subject.id}`;
}

/**
 * The line under a subject's name: the address, or "User" / "Group".
 *
 * `email` arrives only for a caller who also holds `user.read`, so its absence
 * is a permission difference, not a missing address — say what it is instead.
 */
export function subjectCaption(subject: Pick<SubjectDto, 'type' | 'email'>): string {
  return (
    subject.email ?? (subject.type === 'group' ? i18n.t('common:subject.group') : i18n.t('common:subject.user'))
  );
}
